import React from 'react';
import { Paragraph } from '../../../../components/typography';
import { Row, Col } from '../../../../components/grid';
import DeliveryOption from './DeliveryOption';
import { Money, Price } from '../../../../containers/commerce';
import TimeElement from '../../../../components/Date/Time';
import DateElement from '../../../../components/Date/DateElement';
import { createTime, createDate } from '../../../../containers/Date';
import { dateTypes } from '../../../../features/commerce/delivery/dates';
import { deliveryTypes } from '../../../../features/commerce/delivery';
import ReadMore from '../../../../components/ReadMore';
import FadolLeveringUdsolgt from '../../../../components/UdsolgtTexts/FadolLeveringUdsolgt';

const DeliveryDate = createDate(deliveryTypes.deliveryAndPickup)(dateTypes.delivery)(DateElement);
const ReturnDate = createDate(deliveryTypes.deliveryAndPickup)(dateTypes.pickup)(DateElement);
const DeliveryTime = createTime(deliveryTypes.deliveryAndPickup)(dateTypes.delivery)(TimeElement);
const ReturnTime = createTime(deliveryTypes.deliveryAndPickup)(dateTypes.pickup)(TimeElement);

export default ({
  chosen,
  error,
  onChoose,
  hideError,
  component: DeliveryOptionComponent = DeliveryOption,
  step2,
  normalDeliveryCost,
}) => (
  <DeliveryOptionComponent
    onChoose={onChoose}
    choosen={chosen}
    error={error}
    headline={(
      <React.Fragment>
        Levering &amp; afhentning - <Money noDecimal money={normalDeliveryCost} /> samt returret
      </React.Fragment>
    )}
    subheadline="på ubrudte fustager"
    hideError={hideError}
  >
    <Row>
      <Col xs={12} md={step2 ? 12 : 6} padding="0px 15px">
        <Paragraph grey={!chosen && error} fontSize={step2 && 13}>
          Jeg ønsker levering og opsætning,
          samt efterfølgende afhentning af ubrudte fustager,
          samt fadølsanlæg og andet udstyr efter festen
        </Paragraph>
        <FadolLeveringUdsolgt />
        <Paragraph grey={!chosen && error} fontSize="12px">
          Gælder i storkøbenhavn og omegn.
        </Paragraph>
        <ReadMore>
          <Paragraph grey={!chosen && error} fontSize="12px">
            Vores chauffør bærer udstyr og andre varer helt ind hvor du ønsker det og tester at alt virker inden han går igen.
            Øl og anlæg kan sagtens tilsluttes 1 - 2 dage før brug, uden at smagen forringes eller øllet bliver dårligt/fladt.
          </Paragraph>
          <Paragraph grey={!chosen && error} fontSize="12px" margin={step2 && '10px 0'}>
            Online betaling hæves først efter afhentning og kun for det faktiske forbrug.
            Ubrugte fustager refunderes til fuld pris på nær <Price varenr="641" /> pr. fustage.
          </Paragraph>
        </ReadMore>
      </Col>
      <Col xs={12} md={step2 ? 12 : 6} padding="0px 15px">
        <Row greyLight={step2 && true}>
          <Col xs={12} padding="10px 15px 0px 15px">
            <DeliveryDate timeComponent={<DeliveryTime />} isSmall={step2}>
              Leveringsdato:
            </DeliveryDate>
            <ReturnDate
              timeComponent={<ReturnTime />}
              disabledPlaceholder="Vælg leveringsdato først"
              isSmall={step2}
            >
              Returdato:
            </ReturnDate>
          </Col>
        </Row>
      </Col>
    </Row>
  </DeliveryOptionComponent>
);
